<template>
  <div class="layout">
    <div class="layout__header">
      <h3>Detalle de retención</h3>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              :tooltip="modelValue.selectedImpuesto!==null && modelValue.selectedImpuesto!==undefined?modelValue.selectedImpuesto.nombre:'Seleccione...'"
              label="nombre"
              :options="impuestos"
              @input="cargarTarifas"
              v-model="modelValue.selectedImpuesto"
              id="impuesto"
              placeholder="Seleccione..."
            ></v-select>
            <label for="impuesto">Impuesto</label>
            <span v-if="errores.selectedImpuesto" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.selectedImpuesto[0] }}</strong>
            </span>
          </div>
        </div>
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              :tooltip="modelValue.selectedTarifa!==null&&modelValue.selectedTarifa!==undefined?modelValue.selectedTarifa.nombre:'Seleccione...'"
              label="nombre"
              :options="tarifas"
              @input="setearPorcentaje"
              v-model="modelValue.selectedTarifa"
              id="tarifa"
              placeholder="Seleccione..."
            ></v-select>
            <label for="tarifa">Tarifa de impuesto</label>
            <span v-if="errores.selectedTarifa" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.selectedTarifa[0] }}</strong>
            </span>
          </div>
        </div>
        <div class="form-field">
          <input-field
            vMoney
            :format="money"
            @input="calcularValor"
            v-model="modelValue.base_imponible"
            id="baseImponible"
            placeholder="$ ##.##"
          >
            <span>Base imponible</span>
            <span v-if="errores.base_imponible" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.base_imponible[0] }}</strong>
            </span>
          </input-field>
        </div>
        <div v-show="esBanano" class="form-field">
          <input-field
            vMoney
            :format="int"
            v-model="modelValue.numero_cajas"
            id="numero_cajas"
          >
            <span>Número de cajas</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div v-show="!venta" class="form-field select2">
          <div class="select2-field">
            <v-select
              :tooltip="selectedSustento != null?selectedSustento.nombre:'Seleccione...'"
              label="nombre"
              :options="sustentosTributarios"
              @input="inputSustento"
              v-model="selectedSustento"
              id="sustento_tributario"
              placeholder="Seleccione..."
            ></v-select>
            <label for="sustento_tributario">Sustento Tributario</label>
          </div>
        </div>
        <div class="form-field">
          <input-field
            vMoney
            :format="porcentaje"
            :readonly="!venta"
            @input="calcularValor"
            v-model="modelValue.porcentaje"
            id="porcentaje"
            placeholder="###.## %"
          >
            <span>Porcentaje</span>
          </input-field>
        </div>
        <div class="form-field">
          <input-field
            vMoney
            :format="money"
            readonly
            v-model="modelValue.valor"
            id="porcentaje"
            placeholder="$ ###.##"
          >
            <span>Valor</span>
          </input-field>
        </div>
        <div v-show="esBanano" class="form-field">
          <input-field
            vMoney
            :format="money"
            v-model="modelValue.precio_caja"
            id="precio_caja"
            placeholder="$ ##.##"
          >
            <span>Precio de caja</span>
          </input-field>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="$emit('cancelar')" class="btn-danger btn--text">
        <i class="fa fa-ban"></i>
        <span>Cancelar</span>
      </button>
      <button @click="aceptar" class="btn-success" type="button">
        <i class="fa fa-save"></i>
        <span>Aceptar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: false,
      default: function() {
        return {
          selectedTarifa: {
            nombre: ""
          },
          base_imponible: 0,
          porcentaje: 0,
          valor: 0,
          selectedImpuesto: {
            nombre: ""
          },
          id_sustento_tributario: '',
          numero_cajas: 0,
          precio_caja: 0
        };
      }
    },
    impuestos: {
      type: Array,
      required: true
    },
    baseImponibleIva: {
      required: true
    },
    baseImponibleIsd: {
      required: true
    },
    baseImponibleRenta: {
      required: true
    },
    codigoIva: {
      required: true,
      type: String
    },
    codigoRenta: {
      required: true,
      type: String
    },
    codigoIsd: {
      required: true,
      type: String
    },
    venta: {
      required: false,
      type: Boolean,
      default: false
    },
    fechaEmision: {
      required: false,
      default: function(){
        return null;
      }
    },
    sustentosTributarios: {
      type: Array,
      required: false,
      default: function () {
        return [];
      }
    }
  },
  data: function() {
    return {
      selectedSustento: null,
      modelValue: this.value,
      money: money,
      int: int,
      porcentaje: porcentaje,
      errores: {
        selectedTarifa: undefined,
        base_imponible: undefined
      },
      tarifas: [],
      url: url
    };
  },
  methods: {
    inputSustento: function () {
      if (this.selectedSustento != null)
        this.modelValue.id_sustento_tributario = this.selectedSustento.id_sustento_tributario;
      else 
        this.modelValue.id_sustento_tributario = '';
    },
    calcularValor: function() {
      let valor = 0;
      let baseImponible = parseFloat(this.modelValue.base_imponible);
      let porcentaje = parseFloat(this.modelValue.porcentaje);
      if (!isNaN(baseImponible) && !isNaN(porcentaje))
        valor = baseImponible * (porcentaje / 100);
      this.modelValue.valor = Math.round(valor * 100) / 100;
    },
    setearPorcentaje: function() {
      let detalle = this.modelValue;
      if (detalle.selectedTarifa !== null)
        detalle.porcentaje = detalle.selectedTarifa.porcentaje;
      else detalle.porcentaje = 0;
    },
    aceptar: function() {
      if (!this.venta && this.selectedSustento == null) {
        swal('Debe seleccionar un sustento tributario.', 'Aviso', 'warning');
        return;
      }
      if (this.esBanano) {
        let numCajas = parseInt(this.modelValue.numero_cajas);
        if (isNaN(numCajas))
          numCajas = 0;
        if (numCajas == 0) {
          swal('Debe ingresar un valor de cajas mayor a 0.', 'Aviso', 'warning');
          return;
        }
      }
      else {
        this.modelValue.numero_cajas = 0;
        this.modelValue.precio_caja = 0;
      }
      let errores = false;
      if (
        this.modelValue.selectedTarifa === null ||
        this.modelValue.selectedTarifa.nombre === ""
      ) {
        this.errores.selectedTarifa = [
          "Debe seleccionar un impuesto a retener."
        ];
        errores = true;
      }
      if (this.modelValue.base_imponible === "") {
        this.errores.base_imponible = ["Debe ingresar la base imponible."];
        errores = true;
      }
      if (!errores) this.$emit("input", this.modelValue);
      else swal("Hay errores de validación.", "Aviso", "warning");
    },
    consultarTarifas: function() {
      if (this.modelValue.selectedImpuesto != null && this.fechaEmision != null) {
        let that = this;
        axios
          .get(
            this.url +
              "/impuestos/" +
              this.modelValue.selectedImpuesto.id_impuesto + "/" +
              this.fechaEmision +
              "/retenciones"
          )
          .then(function(response) {
            that.tarifas = response.data;
          });
      }      
    },
    cargarTarifas: function() {
      if (
        this.modelValue.selectedImpuesto !== null &&
        this.modelValue.selectedImpuesto.descripcion !== ""
      ) {
        this.modelValue.selectedTarifa = {
          nombre: ""
        };
        this.consultarTarifas();
      } else
        this.modelValue.selectedTarifa = {
          nombre: ""
        };
    }
  },
  mounted: function() {
    if (this.modelValue.selectedImpuesto !== null) this.consultarTarifas();
    for (let i = 0; i < this.sustentosTributarios.length; i++) {
      if (this.sustentosTributarios[i].id_sustento_tributario == this.modelValue.id_sustento_tributario) {
        this.selectedSustento = this.sustentosTributarios[i];
        break;
      }
    }
  },
  watch: {
    value: function(value) {
      this.modelValue = value;
    },
    "modelValue.selectedTarifa": function(value) {
      if (value !== null && value !== undefined) {
        if (
          value.id_impuesto === this.codigoIva &&
          this.baseImponibleIva !== null
        )
          this.modelValue.base_imponible = this.baseImponibleIva;
        else if (
          value.id_impuesto === this.codigoRenta &&
          this.baseImponibleRenta !== null
        )
          this.modelValue.base_imponible = this.baseImponibleRenta;
        else if (value.id_impuesto === this.codigoIsd && this.baseImponibleIsd)
          this.modelValue.base_imponible = this.baseImponibleIsd;
        this.calcularValor();
      }
    }
  },
  computed: {
    esBanano: function () {
      if (this.modelValue.selectedTarifa != null) {
        return this.modelValue.selectedTarifa.id_tarifa == '338' || this.modelValue.selectedTarifa.id_tarifa == '340'
        || this.modelValue.selectedTarifa.id_tarifa  == '341' || this.modelValue.selectedTarifa.id_tarifa == '342'
        || this.modelValue.selectedTarifa.id_tarifa == '342A' || this.modelValue.selectedTarifa.id_tarifa == '342B';
      }
      return false;
    },
    baseImponibleEditable: function() {
      let selectedTarifa = this.modelValue.selectedTarifa;
      if (selectedTarifa !== null) {
        if (
          selectedTarifa.id_impuesto === this.codigoRenta &&
          this.baseImponibleRenta !== null
        )
          return false;
        else if (
          selectedTarifa.id_impuesto === this.codigoIva &&
          this.baseImponibleIva !== null
        )
          return false;
        else if (
          selectedTarifa.id_impuesto === this.codigoIsd &&
          this.baseImponibleIsd !== null
        )
          return false;
      }
      return true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/ItemRetencion.vue